module.exports = __webpack_public_path__ + "static/media/community.cd8a3899.svg";